<template>
  <div class="p-4">
    <div class="d-flex">
      <span>
        <h1 class="title">
          <strong>Comentários</strong>
        </h1>
      </span>
      <span>
        <p style="font-size: 0.9rem" class="ml-2 mb-0">({{ totalComments }})</p>
      </span>
    </div>

    <b-form class="pt-2 pb-2" @submit="postComment" @reset="resetForm">
      <b-row>
        <b-col lg="4" md="4" sm="4">
          <b-form-group id="input-group-1" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="formComment.name"
              placeholder="Nome"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col lg="8" md="8" sm="8">
          <b-form-group id="input-group-2" label-for="input-2">
            <b-form-input
              id="input-2"
              v-model="formComment.email"
              type="email"
              placeholder="E-mail"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col>
          <b-form-group id="input-group-3" label-for="input-3">
            <b-form-textarea
              id="input-3"
              v-model="formComment.description"
              placeholder="Descrição"
              maxLength="1000"
              rows="4"
              required
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <div class="d-flex justify-content-end">
        <b-button :disabled="progressSave" type="submit" variant="primary"
          >Publicar</b-button
        >
      </div>
    </b-form>
    <Comment v-for="comment in comments" :key="comment.id" :comment="comment" />
  </div>
</template>

<script>
import Comment from "./Comment.vue";
import { baseApiUrl, showError } from "@/global";
import axios from "axios";

export default {
  components: { Comment },
  props: ["idArticle", "comments"],
  data: function () {
    return {
      progressSave: false,
      formComment: {
        email: "",
        name: "",
        description: "",
      },
    };
  },
  computed: {
    totalComments() {
      return this.comments.length;
    },
  },
  methods: {
    resetForm(event) {
      event.preventDefault();
      this.formComment.email = "";
      this.formComment.name = "";
      this.formComment.description = "";
    },
    postComment(event) {
      event.preventDefault();
      const comment = {
        name: this.formComment.name,
        email: this.formComment.email,
        description: this.formComment.description,
      };

      this.progressSave = true;
      axios
        .post(
          `${baseApiUrl}/api/publico/artigos/${this.idArticle}/comentarios`,
          comment
        )
        .then((res) => {
          if (res !== undefined) {
            this.$toasted.global.defaultSuccess();
            this.resetForm(event);
            this.progressSave = false;
          }
          this.progressSave = false;
        })
        .catch((error) => {
          this.progressSave = false;
          if (error.response.data.fields !== undefined) {
            error.response.data.fields.forEach((element) => {
              showError(element.userMessage);
            });
          }else {
            showError(error);
          }
        });
    },
  },
};
</script>
